import { paths } from '../../../../../common/constants/pathVariables';
import { mobiilivarmenneMsg, omaElisaForCompaniesMsg, t } from '../../../../../common/i18n';
import { Mobiilivarmenne } from '../../../../../components/MobiiliVarmenne/Mobiilivarmenne';
import { SubscriptionsLayout } from '../../../../../components/SubscriptionsLayout/SubscriptionsLayout';

export const MobiilivarmennePath = () => (
  <SubscriptionsLayout
    breadCrumbs={[
      { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
      { name: t.PKEZ(mobiilivarmenneMsg) },
    ]}
  >
    <Mobiilivarmenne />
  </SubscriptionsLayout>
);
